import * as React from 'react';
import { CnEllipsis } from '@/components/cn-ellipsis';
import { FormatText } from './text';
export const FormatMultipleText = (props) => {
    const { mode, value = '- -' } = props;
    if (mode === 'simple') {
        if (Array.isArray(value)) {
            return React.createElement(FormatText, { mode: mode, value: value[0] });
        }
        return React.createElement(CnEllipsis, null, value);
    }
    if (Array.isArray(value)) {
        return (React.createElement(React.Fragment, null, value.map((item) => (React.createElement("div", null,
            React.createElement(FormatText, { mode: mode, value: item }))))));
    }
    return React.createElement(React.Fragment, null, value);
};
